/*
 * @Descripttion: 
 * @Author: cb
 * @Date: 2021-04-22 11:47:08
 */

import { LaunchEvent, ThinkingAnalyticsController } from "./ThinkingAnalyticsController";

const { ccclass, property } = cc._decorator;

const wx = window["wx"] || window["tt"]


//cc.macro.ENABLE_MULTI_TOUCH=false
// cc.dynamicAtlasManager.closeMyCode=true
// cc.macro.ENABLE_TRANSPARENT_CANVAS = true

let useDynamic = true
if (useDynamic) {
    cc.macro.CLEANUP_IMAGE_CACHE = false;
    cc.dynamicAtlasManager.enabled = true;
    cc.dynamicAtlasManager.maxAtlasCount = 4;
    cc.dynamicAtlasManager.maxFrameSize = 410;
    cc.dynamicAtlasManager.textureSize = 2048;
    cc.macro.ENABLE_NATIVE_TTF_RENDERER = false
    //统计动态合图持有的贴图
    //@ts-ignore
    if (cc.dynamicAtlasManager.__insertSpriteFrame == null) {
        //@ts-ignore
        cc.dynamicAtlasManager.__insertSpriteFrame = cc.dynamicAtlasManager.insertSpriteFrame
        //@ts-ignore
        cc.dynamicAtlasManager.__reset = cc.dynamicAtlasManager.reset
        cc.dynamicAtlasManager.insertSpriteFrame = function (spriteFrame: cc.SpriteFrame) {

            //@ts-ignore
            let frame = cc.dynamicAtlasManager.__insertSpriteFrame(spriteFrame)
            if (frame) {
                //@ts-ignore
                cc.dynamicAtlasManager.holdTextureSet.add(spriteFrame._texture._uuid)
            }
            return frame
        }
        cc.dynamicAtlasManager.reset = function () {
            //@ts-ignore
            cc.dynamicAtlasManager.holdTextureSet = new Set();
            //@ts-ignore
            cc.dynamicAtlasManager.__reset()
        }
    }
    //@ts-ignore
    cc.dynamicAtlasManager.holdTextureSet = new Set()

} else {
    cc.dynamicAtlasManager.enabled = false
    cc.macro.CLEANUP_IMAGE_CACHE = true;
    cc.dynamicAtlasManager.maxFrameSize = 220
    cc.macro.ENABLE_NATIVE_TTF_RENDERER = false
}

if (!CC_EDITOR) {
    cc["SL_CONFIG_LABEL_LAZY_INIT"] = true
    cc["SL_CONFIG_LABEL_LAZY_INIT_ONCE"] = true
}

if (CC_EDITOR) {
    // 重写update方法 达到在编辑模式下 自动播放动画的功能
    sp.Skeleton.prototype['update'] = function (dt) {
        if (CC_EDITOR) {
            cc['engine']._animatingInEditMode = 1;
            cc['engine'].animatingInEditMode = 1;
        }
        if (this.paused) return;

        dt *= this.timeScale * sp['timeScale'];

        if (this.isAnimationCached()) {

            // Cache mode and has animation queue.
            if (this._isAniComplete) {
                if (this._animationQueue.length === 0 && !this._headAniInfo) {
                    let frameCache = this._frameCache;
                    if (frameCache && frameCache.isInvalid()) {
                        frameCache.updateToFrame();
                        let frames = frameCache.frames;
                        this._curFrame = frames[frames.length - 1];
                    }
                    return;
                }
                if (!this._headAniInfo) {
                    this._headAniInfo = this._animationQueue.shift();
                }
                this._accTime += dt;
                if (this._accTime > this._headAniInfo.delay) {
                    let aniInfo = this._headAniInfo;
                    this._headAniInfo = null;
                    this.setAnimation(0, aniInfo.animationName, aniInfo.loop);
                }
                return;
            }

            this._updateCache(dt);
        } else {
            this._updateRealtime(dt);
        }
    }
}
@ccclass
export default class HelloSandglass extends cc.Component {

    @property(cc.Node)
    node_loading: cc.Node = null;

    @property(cc.Node)
    progressBar: cc.Node = null;

    @property(cc.Label)
    txt_loading: cc.Label = null;

    private loadingProgress: number = 0
    private loadingDuration: number = 12;
    private allLoadingComplete: boolean = false

    // LIFE-CYCLE CALLBACKS:
    onLoad() {
        cc.assetManager.downloader.maxRequestsPerFrame = 128 //大一点？
        ThinkingAnalyticsController.ins.init()
        ThinkingAnalyticsController.ins.launchEvent(LaunchEvent.Loading, { type: "start" })

        if (cc.sys.platform == cc.sys.WECHAT_GAME) {
            this.checkUpdateVersion(() => {
            })
            this.onCompleteOneEvent()
            wx.showShareMenu({
                menus: ['shareAppMessage', 'shareTimeline'],
                withShareTicket: true
            })
            let fps = cc.sys.os == cc.sys.OS_IOS ? 40 : 60
            wx.setPreferredFramesPerSecond(fps);//微信降低帧率，防止发热
            cc.game.setFrameRate(fps)
            wx.setKeepScreenOn({ keepScreenOn: true });
        } else {
            this.onCompleteOneEvent()
        }

        this.node.on("size-changed", this.resetFitMode, this);
        this.resetFitMode();
    }

    private resetFitMode() {
        /*
        if (!cc.sys.isMobile) {
            return;
        }
        */
        let designSize = cc.view.getDesignResolutionSize();
        let scaleWs = cc.winSize.height / cc.winSize.width;
        let minScale = 1.77; //微信pc

        if (scaleWs < minScale) {
            cc.view.setDesignResolutionSize(designSize.width, designSize.height, cc.ResolutionPolicy.SHOW_ALL);
        }
    }

    private onCompleteOneEvent() {
        this.node_loading.active = true

        this.loadRes()

        if (cc.sys.platform == cc.sys.WECHAT_GAME) {

        }
    }
    setLoadingText(str: string) {
        this.txt_loading.string = str
    }
    setLoadingProgress(p) {
        let sp = this.progressBar.getComponent(cc.Sprite)
        sp.fillRange = p
    }
    async loadRes() {
        this.scheduleOnce(() => {
            if (cc.sys.platform == cc.sys.WECHAT_GAME) {
                wx.showModal({
                    title: '提示',
                    content: '您的网络不稳定，请检查网络连接。',
                    confirmText: "重启游戏",
                    success(res) {
                        if (res.confirm) {
                            console.log('用户点击确定')
                            wx.restartMiniProgram && wx.restartMiniProgram();
                        } else if (res.cancel) {
                            console.log('用户点击取消')
                        }
                    }
                })
            }
        }, 30)
        await this.loadSubPackage('ui', '正在初始化...', 0.2)
        await Promise.all([
            this.loadSubPackage('textures', '正在初始化...', 0.3),
            this.loadSubPackage('spine', '正在初始化...', 0.5),
            this.loadSubPackage('scripts', '正在初始化...', 0.65),
            this.loadSubPackage('configs', '正在初始化...', 0.85),
            this.loadSubPackage('prefab', '正在初始化...', 0.95),
        ])
        await this.loadScene('正在加载场景', 1)
        this.loadingDuration = 0.5
        this.allLoadingComplete = true;
        ThinkingAnalyticsController.ins.launchEvent(LaunchEvent.LoadComplete, {})
    }

    loadSubPackage(name: string, des: string, percent: number = 0.2) {
        ThinkingAnalyticsController.ins.launchEvent(LaunchEvent.Loading, { type: name })
        this.setLoadingText(des)
        return new Promise((resolve, reject) => {
            cc.assetManager.loadBundle(name, (err, bundle) => {
                if (!err) {
                    ThinkingAnalyticsController.ins.launchEvent(LaunchEvent.Loading, { type: name + "_end" })
                    resolve(null)
                } else {
                    ThinkingAnalyticsController.ins.launchEvent(LaunchEvent.Loading, { type: name + "_error" })
                    console.error("loadSubPackage" + name, err)
                }
            })
        })

    }
    loadScene(tip, percent) {
        ThinkingAnalyticsController.ins.launchEvent(LaunchEvent.Loading, { type: "loadScene" })
        return new Promise((resolve, reject) => {
            this.setLoadingText(tip)
            cc.director.preloadScene('GameScene', () => {

                cc.assetManager.getBundle('prefab').load('login/LoginWin', (e, asset) => {
                    // this.setLoadingProgress(percent)
                    resolve(null)
                })
            })
        })
    }
    checkUpdateVersion(callback: Function) {
        if (wx.getUpdateManager) {
            if (cc.sys.os == cc.sys.OS_WINDOWS) {
                callback && callback()//pc版本有点问题
                return
            }


            const updateManager = wx.getUpdateManager();
            console.log('检查版本-----------')

            if (!updateManager.onCheckForUpdate) {
                callback && callback()
                return
            }
            // wx.showToast({ title: '检查新版本', icon: 'loading', duration: 4000 })
            updateManager.onCheckForUpdate((res) => {
                console.log('是否获取版本', res);
                this.unscheduleAllCallbacks()
                if (res.hasUpdate) {
                    updateManager.onUpdateReady(() => {
                        // updateManager.applyUpdate();
                        wx.showModal({
                            title: '更新提示',
                            content: '新版本已经下载好，请重启应用。',
                            success: function (result) {
                                if (result.confirm) { // 点击确定，调用 applyUpdate 应用新版本并重启
                                    updateManager.applyUpdate();
                                } else {
                                    callback && callback()
                                }
                            }

                        });


                    })
                    updateManager.onUpdateFailed(() => {
                        wx.showModal({
                            title: '已经有新版本喽~',
                            content: '请您删除当前小程序，到微信 “发现-小程序” 页，重新搜索打开哦~',
                            success: function (result) {
                                callback && callback()
                            }
                        })
                    })
                } else {
                    callback && callback()
                }
            })
        } else {
            console.log('检查版本2-----------')
            wx.showModal({
                title: '溫馨提示',
                content: '当前微信版本过低，无法使用该功能，请升级到最新微信版本后重试。'
            })
            callback && callback()
        }
    }

    cc_onClickRepair() {
        HelloSandglass.clickRepair();
    }

    update(dt: number) {
        this.loadingProgress += dt / this.loadingDuration;
        if (this.allLoadingComplete == false) {
            this.loadingProgress = Math.min(0.9, this.loadingProgress)
        }
        this.setLoadingProgress(this.loadingProgress)
        if (this.loadingProgress >= 1) {
            this.gotoEntry()
        }
    }

    private gotoEntry() {
        if (this.allLoadingComplete == false) {
            return
        }
        cc.director.loadScene('GameScene')
    }

    public static clickRepair() {
        if (cc.sys.platform == cc.sys.WECHAT_GAME) {
            wx.showModal({
                title: '提示',
                content: '清理本地缓存，完成后会退出游戏，是否继续？',
                success(res) {
                    if (res.confirm) {
                        console.log('用户点击确定')
                        cc.assetManager.cacheManager?.clearCache()
                        wx.restartMiniProgram && wx.restartMiniProgram();
                    } else if (res.cancel) {
                        console.log('用户点击取消')
                    }
                }
            })
            return;
        }
        if (!cc.sys.isNative) {
            cc.assetManager.cacheManager?.clearCache()
            cc.game.restart();
            return;
        }
    }

}
